export var EMFFilterType;
(function (EMFFilterType) {
    EMFFilterType["CHECKBOX"] = "checkbox";
    EMFFilterType["RADIO"] = "radio";
    EMFFilterType["RANGE"] = "range";
    EMFFilterType["NESTED_RADIO"] = "nestedRadio";
})(EMFFilterType || (EMFFilterType = {}));
